import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartComponent } from './pages/cart/cart.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { shoppingRoutingModule } from './shopping-routing.module';
import { OrderSummaryComponent } from './pages/order-summary/order-summary.component';
import { ShoppingComponent } from './shopping.component';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '@AppCore/core.module';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { MessagesModule } from 'primeng/messages';
import { SkeletonModule } from 'primeng/skeleton';
import { AddressFormComponent } from '../../components/address-form/address-form.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { OtpVerifyComponent } from "../auth/components/otp-verify/otp-verify.component";
import { AuthModule } from '../auth/auth.module';
@NgModule({
  declarations: [
    CartComponent,
    CheckoutComponent,
    OrderSummaryComponent,
    ShoppingComponent,
  ],
  imports: [
    CommonModule,
    shoppingRoutingModule,
    FormsModule,
    CoreModule,
    ProgressSpinnerModule,
    DialogModule,
    MessagesModule,
    SkeletonModule,
    AddressFormComponent,
    RadioButtonModule,
    OtpVerifyComponent,
    AuthModule
],

  exports: [CartComponent],
})
export class ShoppingModule {}
